import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets window scroll to the top whenever the route's pathname changes.
 *
 * React Router preserves the previous scroll position across client-side
 * navigations, which made links clicked from the footer (e.g. About Us / FAQ)
 * open the destination page scrolled to the bottom. We scroll to the top on
 * every pathname change, but leave in-page hash navigations (#section) alone so
 * anchor links still jump to their target.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
